'use client';
import { getText } from '@/utils/text/text';
import './styles/@theme';

type BreadcrumbsProps = {
    links: {
        label: string;
        href?: string;
    }[];
};

export const Breadcrumbs = (props: BreadcrumbsProps) => {
    const links = props.links.slice();
    // Add first link for home
    links.unshift({ label: getText({ text: `common.product.${process.env.PRODUCT}` }), href: '/' });

    return (
        <nav className="breadcrumbs">
            {links.map(({ label, href }, idx) => (
                <span key={label}>
                    <a href={href ?? '#'}>{label}</a>
                    {idx < links.length - 1 && <span className="separator"> / </span>}
                </span>
            ))}
        </nav>
    );
};
